module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/DensityCalculator-ab7134ab38f55fe7c980a7acf4f0c08d.jpg";